const steps = [
  {
    step: 'Диагностика',
    icon: 'ri-search-eye-line',
    desc: 'Изучаем компанию, проводим интервью с руководителями, анализируем звонки, переписки, CRM и текущую систему продаж.',
  },
  {
    step: 'Индивидуальная программа',
    icon: 'ri-file-list-3-line',
    desc: 'Каждая программа создаётся под конкретный бизнес. Не используем типовые тренинги — только то, что нужно именно вам.',
  },
  {
    step: 'Практика',
    icon: 'ri-tools-fill',
    desc: '80% времени — упражнения, переговорные поединки, деловые игры, разбор кейсов компании и реальных звонков.',
  },
  {
    step: 'Работа «в поле»',
    icon: 'ri-road-map-line',
    desc: 'При необходимости: совместные переговоры и звонки, разбор переписки, работа с руководителем отдела продаж.',
  },
  {
    step: 'Сопровождение',
    icon: 'ri-chat-smile-3-line',
    desc: 'Telegram-поддержка, разбор кейсов, домашние задания, контроль внедрения и регулярная обратная связь.',
  },
  {
    step: 'Измерение результата',
    icon: 'ri-bar-chart-box-line',
    desc: 'Конверсия, средний чек, маржинальность, KPI — отслеживаем динамику и подтверждаем эффект обучения цифрами.',
  },
];

export default function WhyProgramsWork() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему наши программы работают
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">
          Фирменная методология, построенная на диагностике, практике и сопровождении — от первой встречи до измеримого результата
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {steps.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 md:p-6 hover:bg-teal-50 hover:ring-2 hover:ring-teal-200 transition-all group">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                  <i className={`${item.icon} text-xl text-white`}></i>
                </div>
                <div className="text-teal-600 text-xs font-bold uppercase tracking-wider">
                  Шаг {i + 1}
                </div>
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-2 group-hover:text-teal-700 transition-colors">
                {item.step}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 max-w-2xl mx-auto bg-teal-50 rounded-2xl p-6 md:p-8">
          <p className="text-gray-800 text-base md:text-lg font-medium leading-relaxed">
            Я не провожу одинаковые тренинги. Каждая программа создаётся под конкретную компанию, отрасль, уровень подготовки сотрудников и бизнес-задачи.
          </p>
        </div>
      </div>
    </section>
  );
}